import { cn } from '@ds';

type UnreadBadgeProps = {
  count: number;
  isMuted?: boolean;
};

export const UnreadBadge = ({ count, isMuted }: UnreadBadgeProps) => (
  <span
    className={cn([
      'inline-flex items-center justify-center shrink-0 min-w-[18px] px-1 py-[2px] rounded-[14px] text-[10px] font-medium leading-none text-white',
      isMuted ? 'bg-base-40' : 'bg-info-40',
    ])}
  >
    {count}
  </span>
);
